import { render } from "./HomeBanner.vue?vue&type=template&id=f0f3c612"
import script from "./HomeBanner.vue?vue&type=script&lang=js"
export * from "./HomeBanner.vue?vue&type=script&lang=js"

import exportComponent from "D:\\mercado-web-1.2.41 - mercado-web-1.2.50\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__